// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\" data-cy=\"transaction-date\" ng-bind=\"row.entity.Transacted | date:'short'\"></div>\n</div>";
// Exports
module.exports = code;